export default __webpack_public_path__ + "static/media/rotura_prematura_membranas.b89ab6da.pdf";